<template>
	<div class="tab-areas">
		<v-layout class="wrapper-big">
			<v-flex xs6>
				<v-layout align-center class="h-100">
					<v-flex xs4>
						<v-checkbox 
							v-model="select.selectAll"
							color="success"
							@change="changeSelectAll($event)"
						></v-checkbox>
					</v-flex>
					<v-flex xs5>
						<div class="tab-areas-text center"
							:style="`color:${$appColors.primary}`"
						>ÁREAS</div>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs6>
				<v-layout class="h-100">
					<v-flex xs6 align-self-center>
						<div class="tab-areas-text">PUNTOS</div>
					</v-flex>
					<v-flex xs5 align-self-center>
						<app-tooltip-button
							img="/static/img/diagnosis/points.svg"
							size="15"
							text="Modificar todos los puntos"
							@click-icon="toggleInput"
							v-if="!showInput"
						/>
						<input 
							v-else
							type="number"
							class="input-number"
							:style="`color:${$appColors.info}`"
							@input="changeTotal($event.target.value)"
							@keyup.enter="toggleInput($event)"
							v-model="valueTotal"
						>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-layout 
			v-for="(group, indexGroup) in select.groups"
			:key="group.id"
			class="wrapper-big wrapper-box"
		>
			<v-flex xs6 class="d-flex-a-center">
				 <v-checkbox
				 	class="tab-areas-checkbox"
					:class="{ 'disable-checkbox': !group.totalEmployees }"
					color="success"
				 	:disabled="!group.totalEmployees"
					hide-details
					:label="group.name"
					@change="changeSelect(group, indexGroup)"
				 	v-model="group.selected" 
				></v-checkbox>
			</v-flex>
			<v-flex xs4 class="d-flex-a-center">
				<input
					class="input-area"
					type="number"
					v-model="group.value"
					@input="changeValue"
				>
			</v-flex>
			<v-flex xs2 class="total-employees">
				<button
					type="button"
					:class="[
						'areas-employees-btn',
						{ 'total-employees-disabled': !group.totalEmployees }
					]"
					:style="`color:${!group.totalEmployees ? $appColors.info : $appColors.primary}`"
					:disabled="!group.totalEmployees || !group.selected"
					@click="$emit('select-areas-employees', { tool: select, area: group })"
				>
					{{group.totalEmployees}}
				</button>
			</v-flex>
		</v-layout>
	</div>
</template>
<script>
function toggleInput() {
	this.showInput = !this.showInput;
	this.valueTotal = null;
}

function changeSelect(area, index) {
	const newArea = this.selectAllEmployees(area);
	this.$set(this.select.groups, index, newArea);
	this.select.selectAll = this.select.groups.every(s => s.selected);
	this.$emit('validate-value', this.select);
}

function selectAllEmployees(area) {
	const newArea = area;
	newArea.employees = area.employees.map((e) => {
		const newE = e;
		newE.selected = area.selected;
		return newE;
	});
	return newArea;
}

function changeSelectAll(value) {
	this.select.groups.forEach((a, i) => {
		const area = a;
		area.selected = value;
		this.changeSelect(area, i);
	});
	// this.select.groups = this.select.groups.map((s) => {
	// 	const newSelect = { ...s };
	// 	newSelect.selected = s.totalEmployees ? value : false;
	// 	return newSelect;
	// });
	// this.$emit('validate-value', this.select);
}

function changeTotal(value) {
	this.select.groups = this.select.groups.map((s) => {
		const newSelect = { ...s };
		newSelect.value = value !== '' ? value : 1;
		return newSelect;
	});
	this.$emit('validate-value', this.select);
}

function changeValue() {
	this.$emit('validate-value', this.select);
}

function data() {
	return {
		selectAll: false,
		showInput: false,
		valueTotal: null,
		selectGroup: {},
	};
}
export default {
	name: 'tab-areas',
	data,
	methods: {
		toggleInput,
		changeSelect,
		changeSelectAll,
		changeTotal,
		changeValue,
		selectAllEmployees,
	},
	props: {
		select: {
			type: Object,
			default: () => {},
		},
	},
};
</script>
<style lang="scss">
	.tab-areas {
		&-text {
			font-size: map-get($sizes, small);
		}

		.wrapper-big {
			border-bottom: 1px solid map-get($colors, gray-slider);
			height: 55px;
			padding-left: 25px;
		}

		.h-100 {
			height: 100%;
			margin: 0;
		}

		.wrapper-box {
			.v-input {
				margin-top: 0px;
			}
		}

		.d-flex-a-center {
			align-items: center;
			display: flex;
		}

		.center {
			text-align: center;
		}

		.input-area {
			border: 1px solid color(gray-slider);
			border-radius: 4px;
			height: 37px;
			outline: none;
			text-align: center;
			width: 50px;
		}

		.input-number {
			border-radius: 4px;
			border: 1px solid color(gray-slider);
			outline: none;
			text-align: center;
			width: 100%;
		}

		.total-employees {
			align-items: center;
			display: flex;
		}
	}

	.areas-employees-btn {
		background-color: transparent;
		border: none;
		text-decoration: underline;
	}

	.disable-checkbox {
		&.v-input--is-disabled .material-icons {
			opacity: 0.2;
		}
	}

	.total-employees-disabled {
		opacity: 0.3;
	}

	.tab-areas-checkbox {
		.v-label {
			color: #606560 !important;
			font-family: font(regular);
			font-size: size(small13);
		}
	}
</style>




// WEBPACK FOOTER //
// src/components/diagnosis/tab-areas.vue